// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {Buildings2,  Setting2, ShieldSecurity} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  setting:Setting2,
  company:Buildings2,
  roles:ShieldSecurity
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const settings: NavItemType = {
  id: 'group-settings',
  title: <FormattedMessage id="settings"  />,
  icon: icons.setting,
  type: 'group',
  url:'setting',
  permissions:['NL_SETTING_R'],
  children: [
    {
      id: 'setting-company',
      title: <FormattedMessage id="company" />,
      type: 'item',
      url: '/setting/business',
      icon: icons.company,
      permissions:['NL_SETTING_BUSINESS_R','NL_SETTING_BUSINESS_C','NL_SETTING_BUSINESS_U','NL_SETTING_BUSINESS_D','NL_SETTING_BUSINESS_L','NL_SETTING_BUSINESS_U_ST'],
      breadcrumbs: false
    },
   
    {
      id: 'setting-roles-accesses',
      title: <FormattedMessage id="roles-accesses" />,
      type: 'item',
      url: '/setting/roles-accesses',
      icon: icons.roles,
      permissions:['NL_SETTING_ROLES_ACCESS_R','NL_SETTING_ROLES_ACCESS_C','NL_SETTING_ROLES_ACCESS_U','NL_SETTING_ROLES_ACCESS_D','NL_SETTING_ROLES_ACCESS_L','NL_SETTING_ROLES_ACCESS_U_ST'],
      breadcrumbs: false
    },
   
  ]
};

export default settings;
